import { render, staticRenderFns } from "./simple-tasks-info.vue?vue&type=template&id=2457a75c&scoped=true"
import script from "./simple-tasks-info.vue?vue&type=script&lang=js"
export * from "./simple-tasks-info.vue?vue&type=script&lang=js"
import style0 from "./simple-tasks-info.vue?vue&type=style&index=0&id=2457a75c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457a75c",
  null
  
)

export default component.exports